import { CashLoginType } from '@afterpaytouch/portal-api/consumer/lookup'
import { OrderSource } from '@afterpaytouch/portal-api'
import { ActionMobilesLookupResponse } from '@afterpay/verify-service-api'
import { deriveHasCashtag } from '../../state/convergence/helper'

export interface InitialiseLookup {
  hasCashtag?: boolean
  existing: boolean
  shadowAccountExists?: boolean
  email?: string
  merchantId: number
  cashCreationDate?: number
  merchantOrderSource?: OrderSource
  loginType?: CashLoginType
}

export const deepMergeLookupResponse = (emailLookup: InitialiseLookup, mobileLookup: ActionMobilesLookupResponse): InitialiseLookup => {
  // OR the two cashtag signals so a mixed match (email user has no cashtag,
  // mobile finds a Cash user) still routes through the Cash cohort — matches
  // the old `emailLookup.cashtag ?? mobileLookup.cashtag` behavior where a
  // null email cashtag fell through to the mobile cashtag. Preserves
  // `undefined` only when neither lookup carries any cashtag signal.
  const emailHas = emailLookup.hasCashtag
  const mobileHas = deriveHasCashtag(mobileLookup)
  const initialiseMobileLookupResponse = {
    hasCashtag: emailHas === true || mobileHas === true ? true : emailHas ?? mobileHas,
    existing: emailLookup.existing || mobileLookup.existing,
    shadowAccountExists: emailLookup.shadowAccountExists || mobileLookup.shadowAccountExists,
    cashCreationDate: emailLookup.cashCreationDate ?? mobileLookup.creationDate,
    loginType: emailLookup.loginType ?? mobileLookup.loginType,
  }

  return {
    ...emailLookup,
    ...initialiseMobileLookupResponse,
  }
}
